export function init() {
    const featureVideos = document.querySelectorAll('.js-feature-video');

    featureVideos.forEach(video => {
        if (!window.fetch) {
            return 
        }

        let source = video.querySelector('source');

        // Fire off a request to our php file
        fetch(`/vimeo/get-video-src?videoId=${source.dataset.id}`, {
            headers: { 
                "X-Requested-With": "XMLHttpRequest",
                'Accept': 'application/json'
            }
        })
        .then(response => response.json())
        .then(data => {
            source.type = data.type;
            source.src = data.link;

            // This needs setting here for ie9 which doesn't support the 'muted' attribute
            video.muted = true;

            // Load the sources into the video
            video.load();

            // If we are already ready to play, play it now
            if (video.readyState > 3) {
                playVideo(video, true);
            } else { // Otherwise...
                playVideo(video, false);

                setTimeout(function () {
                    video.pause();

                    // Bind a playVideo handler to the canplaythrough event
                    video.addEventListener('canplaythrough', () => {
                        playVideo(video, true);
                    });
                }, 0);
            }
        })
        .catch(error => {
            console.log(error);
        });
    });
}


function showVideo(video) {
    video.classList.add('playing', 'show');
}

function playVideo(video, showVideo) {
    video.play();

    if (showVideo) {
        showVideo(video);
    }
}